import React, { FC } from "react";

import styled from "styled-components";

import { LinkIcon } from "@/assets/icons";
import { useSecuredUrl } from "@/shared/hooks";
import { InsurerLink } from "@/shared/utils";
import { breakpoints } from "@/styles/breakpoints";

const StyledLinkToPartner = styled.a`
    padding-right: 25px;
    margin-left: auto;
    font-size: var(--size-14);
    font-weight: var(--weight-600);
    color: var(--color-secondary);
    @media ${breakpoints.mdMax} {
        padding-top: 10px;
    }
    @media ${breakpoints.xxs} {
        margin-left: 0;
    }

    svg {
        width: 19px;
        height: 19px;
        margin-right: 4px;
        vertical-align: bottom;

        path {
            fill: var(--color-secondary);
        }
    }
`;

type LinkToPartnerProps = {
    id: string | number;
    insurerLink: InsurerLink;
};

const LinkToPartner: FC<LinkToPartnerProps> = ({ id, insurerLink }) => {
    const { onSecureUrlClick } = useSecuredUrl();

    return (
        <StyledLinkToPartner
            data-testid={`secured-url-${id}`}
            href="/"
            title={insurerLink.label}
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onSecureUrlClick(insurerLink.link);
            }}
        >
            <LinkIcon alt="Link Icon" />
            {insurerLink.label}
        </StyledLinkToPartner>
    );
};

export default LinkToPartner;
